export const dataReducers = (state: DataState, action: DataAction): DataState => {
    switch (action.type) {
        case 'loadResearches':
            return {
                ...state,
                researches: action.researches
            };
        case 'loadFields':
            return {
                ...state,
                fields: action.fields
            };
        case 'updateExploreFilter':
            return {
                ...state,
                selectedFilter: action.selectedFilter
            };
        case 'updateSelectedField':
            return {
                ...state,
                selectedField: action.selectedField
            };
        case 'updateSelectedResearch':
            return {
                ...state,
                selectedResearch: action.selectedResearch
            };
        case 'updateSoilData':
            return {
                ...state,
                soilData: action.soilData
            };
        case 'updateDRSYieldData':
            return {
                ...state,
                drsYieldData: action.drsYieldData
            };
        case 'updateNitrateConcentrationData':
            return {
                ...state,
                nitrateConcentrationData: action.nitrateConcentrationData
            };

        case 'updateCropRotationYieldData':
            return {
                ...state,
                cropRotationYield: action.cropRotationYield
            };

        case 'updateCropRotationWeatherYears':
            return {
                ...state,
                cropRotationWeatherYears: action.cropRotationWeatherYears
            };
        case 'updateCoverCropYieldData':
            return {
                ...state,
                coverCropYield: action.coverCropYield
            };
    }
    throw Error(`Received invalid action: ${action}`);
};
